<template>
  <v-dialog v-model="isDialogVisible" max-width="650">
    <v-card class="add-person-dialog">
      <v-btn class="button-close ma-4" icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h4 class="mt-1">Выбeрите документы</h4>
      </v-card-title>
      <v-card-text>
        <v-chip v-for="candidateId in srcCandidates" :key="candidateId" class="ma-2" small close @click:close="setSelectedCandidate(candidateId)">
          {{ getCandidateInfo(candidateId).name }}
        </v-chip>

        <div class="dossier-list mb-8">
          <v-expansion-panels flat multiple accordion  v-model="panel" >
            <v-expansion-panel v-for="candidateId in srcCandidates" :key="candidateId" class="no-border mb-2">
              <v-expansion-panel-header>
                <span class="font-weight-bold">{{ getCandidateInfo(candidateId).name }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-progress-linear v-if="getCandidateInfo(candidateId).loading" indeterminate color="primary"/>
                <div v-else-if="getCandidateInfo(candidateId).documents && !getCandidateInfo(candidateId).documents.length" class="text-gray text-center">
                  У кандидата нет загруженных документов
                </div>
                <v-simple-table v-else>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Название документа</th>
                      <th>Тип документа</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="doc in getCandidateInfo(candidateId).documents" :key="doc.id" class="dossier-row">
                      <td>
                        <v-checkbox v-model="selectedDocumentIds" :value="doc.id" hide-details class="mt-0" @change="onSelectDoc"/>
                      </td>
                      <td>{{ doc.name }}</td>
                      <td>{{ getDocType(doc) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="d-flex justify-end mt-2 mb-3">
          <v-btn outlined color="primary" @click="close()" class="mr-4 px-6">Отменить</v-btn>
          <v-btn @click="save()" color="primary" class="px-9">Выбрать</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { cloneDeep } from 'lodash';
import { DOC_TYPES_TITLES, DOC_TYPES } from '@/common/constants/docTypes';

export default {
name: 'AddProfrgamsDialog',
components: {
},
model: {
  prop: 'value',
  event: 'input',
},
props: {
  value: Boolean,
},
data: () => ({
  strFilter: "",
  selectedDocumentIds: [],
  panel: []
}),
watch: {
  async value(val) {
    if (val) {
      // this.selectedCandidates = cloneDeep(this.srcCandidates ?? [])
      // this.panel = this.srcCandidates.map((_, i) => i);
      this.selectedDocumentIds = [];
      await this.loadDossier();
    }
  },
},
computed: {
  ...mapGetters({
    srcCandidates: 'ai/dossier/selectedCandidates',
    getCandidateInfo: 'ai/dossier/getCandidateInfo',
    user: 'auth/user',
  }),
  isDialogVisible: {
    get() {
      return this.value;
    },
    set(value) {
      if (!value) {
        this.close()
      }
    },
  },
  filter () {
      return (item, search, textKey) => {
        return item[textKey].indexOf(search) > -1
      }
    },

},
methods: {
  ...mapActions({
    loadDossier: 'ai/dossier/loadDossier',
    addFilesFromDosser: 'ai/dossier/addFilesFromDosser',
  }),
  ...mapMutations({
    setSelectedCandidate: 'ai/dossier/setSelectedCandidate',
  }),
  getDocType(item) {
    const key = Object.keys(DOC_TYPES).find(k => DOC_TYPES[k] === item.type);
    return key ? DOC_TYPES_TITLES[key] : 'Не найдено';
  },
  close(ret) {
    this.$emit('input', ret);
  },
  onSelectDoc(ev) {
    console.log(ev)
  },
  async save(ret) {
    await this.addFilesFromDosser(this.selectedDocumentIds)
    this.$emit('ok');
    this.close()
  },
}

}
</script>

<style>
.dossier-list {
  height: 400px;
  overflow-y: scroll;
}

.dossier-row {
  border-top: 1px solid #DEE1EA;
}
/* .no-border, .no-border:before, .no-border::before {
  box-shadow: none !important;
  border: none !important;
}

.no-border >>> .v-expansion-panel {
  box-shadow: none;
  border: none;
} */
</style>
 